import logger from 'ws-scripts/modules/logger';

/**
 * Returns the estimated monthly payment (rounded to the nearest cent)
 * of a loan at a given amount, at a given APR, over a given
 * repayment period.
 *
 * Parameters:
 *	- price (number):  the total cost
 *	- downPayment (number):  the amount paid initially
 *	- apr (number):  the nominal APR in percent (e.g. 6.9% = 6.9)
 *	- termLength (number):  the number of months over which the loan will
 *		be repaid
 *
 * Returns:
 *	- (number):  the estimated monthly payment in dollars rounded to
 *		the nearest cent; returns 0 if no payment could be calculated
 */
export function calculateMonthlyPayment(price, downPayment, apr, termLength) {
	logger.trace('Price: ', price);
	logger.trace('DP: ', downPayment);
	logger.trace('APR: ', apr);
	logger.trace('Term: ', termLength);

	const principal = price - downPayment;
	const monthlyRate = apr / 1200.0;
	let monthlyPayment = 0.0;

	// full MPR payment equation fails when MPR is 0%
	if (monthlyRate) {
		monthlyPayment =
			(monthlyRate +
				monthlyRate / ((1 + monthlyRate) ** termLength - 1)) *
			principal;
	} else {
		// MPR could be zero, in which case finding the payment is
		// a simple calculation
		monthlyPayment = principal / termLength;
	}

	logger.trace('Temp Month: ', monthlyPayment);

	// payment should always be number rounded to the nearest whole number
	monthlyPayment =
		!Number.isNaN(monthlyPayment) && monthlyPayment > 0
			? Math.round(monthlyPayment)
			: 0.0;

	logger.trace('Month: ', monthlyPayment);

	return monthlyPayment;
}



// WEBPACK FOOTER //
// ./src/utils/calculations.js